import React, { Fragment } from "react";
import { useRecoilState } from "recoil";
import { appThemeSelector } from "../../store/selectors";

const Header = () => {
  const [theme, setTheme] = useRecoilState(appThemeSelector);

  return (
    <Fragment>
      <img className="h-8" src={`./${theme.theme[theme.mode].logo}`} alt="" />
    </Fragment>
  );
};

export default Header;
